<template>
  <section class="section section-shaped section-lg my-0">
      <div class="shape shape-style-1 bg-gradient-default">
      </div>
      <div class="container pt-lg-md">
            <div class="row justify-content-center">
                <div class="col-lg-5">
                    <card type="secondary" shadow
                          header-classes="bg-white pb-5"
                          body-classes="px-lg-5 py-lg-5"
                          class="border-0">
                        <template>
                            <div class="text-muted text-center mb-3">
                                <h4>Recuperar Senha</h4>
                                <p class="mb-1">Preencha os campos abaixo com a sua nova senha</p>
                            </div>
                        </template>
                        <template>
                            <form role="form" @submit.prevent method="get">
                                <base-input alternative
                                            v-model="inputs.password1"
                                            type="password"
                                            id="password1"
                                            class="mb-3"
                                            placeholder="Senha"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <base-input alternative
                                            v-model="inputs.password2"
                                            type="password"
                                            id="password2"
                                            class="mb-3"
                                            placeholder="Repita a Senha"
                                            addon-left-icon="ni ni-lock-circle-open">
                                </base-input>
                                <password v-model="inputs.password1" :strength-meter-only="true" @score="updateStrengthText" />
                                <div class="text-muted text-center mb-3">
                                    <small>força da senha:
                                        <span class="font-weight-700" :style="{color}">{{strength_password}}</span>
                                    </small>
                                </div>
                                <div class="text-center">
                                    <base-button nativeType="submit" @click="reset_password($event)" type="primary" class="my-4">Enviar</base-button>
                                </div>
                            </form>
                        </template>
                    </card>
                </div>
            </div>
        </div>
  </section>
</template>

<script>
import Password from 'vue-password-strength-meter'

import { mapActions, mapState, mapGetters } from 'vuex';

import { userMixin } from "@/mixins/userMixin";

export default {
  components: {
    Password
  },
  mixins: [userMixin],
  data() {
    return {
      modal: {
        show: false,
        title: 'Falha na Operação!',
        body: 'Não foi possível completar a operação',
        classe: 'modal-danger',
        icon: 'fa fa-times-circle',
        okButton: 'OK',
      },
    };
  },
  methods: {
    ...mapActions('password', [
      'clearResetStatus',
    ]),
  },
  computed: {
    ...mapGetters('auth', [
        'isAuthenticated',
      ]),
    ...mapState('password', [
        'resetCompleted',
        'resetError',
        'resetLoading',
      ]),
  },
  beforeRouteLeave(to, from, next) {
    this.clearResetStatus();
    this.inputs.password1 = ''
    this.inputs.password1 = ''
    next();
  },
};
</script>
